<template>
<div v-if="modelValue" class="fixed inset-0 z-[999] flex items-end justify-center bg-[rgba(41,34,29,0.4)]">
  <div class="absolute inset-0 " @click="close" data-testid="rm-model-overlay-close" />

  <div
    class="absolute bottom-0 w-full rounded-t-[24px]
           bg-white shadow-2xl flex flex-col"
    :style="{ height: fullHeight, transform: `translateY(${translateY}px)`}"
    data-testid="rm-slider-container"
  >
    <div class="pt-[42px] pb-[40px] flex justify-center" @touchstart="onStart" @touchmove.prevent="onMove" @touchend="onEnd">
      <div class="w-[134px] h-[5px] bg-[#141414] opacity-40 rounded-full" />
    </div>
    <div class="px-[20px] pb-[32px] text-[20px] leading-[23px] font-normal text-[#191919]" data-testid="rm-model-title">
      {{ title }}
    </div>
    <div class="flex-1 overflow-y-auto px-[20px] pb-6">
      <slot />
    </div>
    <div class="px-[20px] pt-[16px] pb-[16px]">
      <button class="w-full h-[53px] rounded-[8px] bg-[#1E1E1E] text-[#f5f5f5] text-[14px] border border-[#2C2C2C]" @click="close" data-testid="rm-close-button">
        Close
      </button>
    </div>
  </div>
</div>
</template>


<script setup lang="ts">
import eventBusGtm from '~/composables/eventBusGtm'
import { useUserStore } from '~/stores/userStore'
import { ref, watch } from "vue";
import { storeToRefs } from 'pinia';
import { useIframeStore } from "@/stores/chatAIStore";
const userStore = useUserStore();
const iframeStore = useIframeStore();
const { isDynamicYieldVariationData } = storeToRefs(iframeStore);

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  title: String,
  isPage: String,
  fullHeight: { type: String, default: '70vh' },
  productData: Object,
  searchQueryData: String
})

const emit = defineEmits(['update:modelValue'])
const startY = ref(0)
const translateY = ref(0)

watch(
  () => props.modelValue,
  (v) => {
    document.body.style.overflow = v ? 'hidden' : ''
    if (v) translateY.value = 0
  }
)

const close = () => {
  emit('update:modelValue', false)
  translateY.value = 0
  const customerId = userStore.data?.customerId ?? null;
    eventBusGtm.emit('trackEvent', {
      event: 'Taia',
      button_name: 'readless',
      screen_name: "taia_summary_product_overview",
      Customer_id: customerId,
      message_id: null,
      Selected_thread_id: null,
      target: null,
      productName: props.productData?.name ?? null,
      productSku: props.productData?.sku ?? null,
      productPrice: props.productData?.price ?? null,
      skuid: null,
      sub_screen: 'taia_summary_product_overview',
      article: null,
      Writing_style_preference: null,
      Content_preference: null,
      ResponseDetail_preference: null,
      Taia_campaign: null,
      search_term:null,
      variationName:isDynamicYieldVariationData.value?.name ?? null,
      experienceName:isDynamicYieldVariationData.value?.experienceName ?? null
  });
}

const onStart = (e: TouchEvent) => {
  startY.value = e.touches[0]!.clientY
}

const onMove = (e: TouchEvent) => {
  const dy = e.touches[0]!.clientY - startY.value
  if (dy > 0) translateY.value = dy
}

const onEnd = () => {
  if (translateY.value > 120) close()
  else translateY.value = 0
}
</script>
<style>
.prose p {
  color: #191919;
}
</style>